<div class="dropdown">
  <button class="dropbtn" (click) = "onCloseDropdown()">Map options<span class="down_arrow mapSprite"></span></button>
  <div id = "dropdownContent" class="dropdown-content"  [ngClass]="{'hideDropdown': hideDropDownMenu}">
    <label class="checkbox">
      <input type='checkbox' [(ngModel)]="TrafficAlertModel" (ngModelChange)="onShowHideTrafficAlerts(TrafficAlertModel)"/>
      <span class="tick"></span><span class="label">Traffic alerts</span>
    </label>
  </div>
</div>